import {useCallback} from "react";

function resolveMpeOptions(settings = {}) {
    return {
        debugMode: settings.debug_mpe === "yes",
        enableMoreInfoLink: settings.enableMoreInfoLink_mpe === "yes",
        logoColor: settings.logoColor_mpe,
        maxAmount: settings.maxAmount_mpe,
        maxTerm: settings.maxTerm_mpe,
        minAmount: settings.minAmount_mpe,
        mpeSelector: settings.mpeSelector_mpe?.replace("&gt;", ">"),
        priceSelector: settings.priceSelector_mpe?.replace("&gt;", ">"),
        storeDisplayName: settings.storeDisplayName_mpe,
        publicId: settings.publicId_mpe,
        displayMicroOffers: settings.display_micro_offer_mpe === "yes",
        displayPrimeOffers: settings.display_prime_offer_mpe === "yes",
        maxMicroAmount: settings.max_micro_amount_mpe,
        primeApr: settings.prime_apr_mpe,
    };
}

export function useMPE({ windowKey = "mpeSettings", payTomorrowKey = "PayTomorrow" } = {}) {
    const initMpe = useCallback((overrides = {}) => {
        const pt = window[payTomorrowKey];
        const rawSettings = window[windowKey]?.mpeOptions ?? {};

        if (!pt?.mpeInit) {
            console.warn(`useMpe: window.${payTomorrowKey}.mpeInit is not available`);
            return;
        }

        pt.mpeInit({ ...resolveMpeOptions(rawSettings), ...overrides });
    }, [windowKey, payTomorrowKey]);

    return {initMpe};
}